/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Event_Count_OneInputs */

const en_calendar_event_count_one = /** @type {(inputs: Calendar_Event_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 event`)
};

const pt_br2_calendar_event_count_one = /** @type {(inputs: Calendar_Event_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 evento`)
};

/**
* | output |
* | --- |
* | "1 event" |
*
* @param {Calendar_Event_Count_OneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_event_count_one = /** @type {((inputs?: Calendar_Event_Count_OneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Event_Count_OneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_event_count_one(inputs)
	return pt_br2_calendar_event_count_one(inputs)
});